// VARIOUS CACHE RELATED CODE
/*global _ localStorage vueapp*/
import store from "Js/store";

//Register watchers for app model - could be moved into site
export const cacheRegListeners = function () {
  _.forEach(store.state.site.content.appCaching, function(c) {
    store.watch( (state) => state.site.content.app[c.path], cacheCbGen(c));
  });  
}

export const cacheAppLoad = function() {
  // TODO pass in state vs vueapp
    _.forEach(vueapp.$store.state.site.content.appCaching, function(c) {
      let val, app = {};
      
      if (c.sessionStorage && c.path in sessionStorage) {
        app[c.path] = JSON.parse(sessionStorage.getItem(c.path));
        vueapp.$store.commit('SET_APP', app);
      
      } 
      else if (c.localStorage && c.path in localStorage) {
        app[c.path] = JSON.parse(localStorage.getItem(c.path));
        vueapp.$store.commit('SET_APP', app);
      }
   })
}

// returns a cb function that is called when a watched app/form key is changed
export const cacheCbGen = function  (c) {
  return function   (newValue,oldValue )  {
    if (c.appSync ) vueapp.$store.state.site.content.app[c.path] = newValue 
    
    c.localStorage ?     localStorage.setItem((c.pathPrefix||'') + c.path , JSON.stringify(newValue)) : null;
    c.sessionStorage ? sessionStorage.setItem((c.pathPrefix||'') + c.path , JSON.stringify(newValue)) : null;
    };
};


export const appSyncCbGen = function  (c, state, ind) {
  return function   (newValue,oldValue )  {
    if (c.appSync) state.windows[ind].formSchema.model[c.path] = newValue 
  };
};

// Register watchers for page models
export const cacheFormAdd = function (state,wndw,ind) {
  let prefix = wndw.formSchema.id + '_' // TODO should be navigational path (slug) of the page
  let modelCaches = wndw.formSchema.modelCaches || // []
  [
    {path:'local',localStorage:true},
    {path:'session',sessionStorage:true},
    {path:'both',localStorage:true ,sessionStorage:true}
  ] // temp simulate a key
  
  _.forEach(modelCaches, function(c) {
      // this f is the getter for the watcher
      c.pathPrefix = prefix
      let cb = store.watch(
      (state) => {
        return state.wndw.windows[ind].formSchema.model[c.path]
      }, 
      cacheCbGen(c), { 
        deep: true 
      });
    state.windows[ind].cacheRemove.push(cb);
    
    // Listener for app if appSync
    if (c.appSync){
      let cb = store.watch(
      (state) => {
        return  state.site.content.app[c.path] 
      }, 
      appSyncCbGen(c, state, ind), {
        immediate: true,
        deep: true
      });
    state.windows[ind].cacheRemove.push(cb);
    }
  });
};

// Getting data from local / session storage
export const cacheFormLoad = function (state,wndw,ind) {
    let prefix = wndw.formSchema.id + '_'
    let caches=wndw.formSchema.modelCaches || []
    _.forEach(caches, function(c) {
      let model = {};
      let fullpath = prefix + c.path
      if (c.sessionStorage && fullpath in sessionStorage) {
        model[c.path] = JSON.parse(sessionStorage.getItem(fullpath));
        Object.assign(state.windows[ind].formSchema.model, model)
      } 
      else if (c.localStorage && fullpath in localStorage) {
        model[c.path] = JSON.parse(localStorage.getItem(fullpath));
        Object.assign(state.windows[ind].formSchema.model, model)
      }
   })
  
};

// Remove watchers for page models via callbacks
export const cacheFormRemove = function  (state,ind) {
   let cbs = state.windows[ind].cacheRemove
  // console.log(`@cacheFormRemove removing {} for ind[${ind}]`, cbs )
  _.forEach(cbs , function(cb,ind, cbs) {
    cb();
  })
  state.windows[ind].cacheRemove=[]
};

// TODO remove
// Returns the cached site if present
export const cacheSiteLoad = function  () {
  
};

// Saves the passed site to cache
export const cacheSiteSave = function  (site) {
  
  
};